export const get = (name: string) => {
  const value = localStorage.getItem(name)
  return value || null
}

export const set = (name: string, value: string) => {
  localStorage.setItem(name, value)
}
